// ============================================================
// ルート別 SEO メタデータの一元管理
// 各ページのタイトル・説明・キーワードをここに集約します。
// ============================================================

export interface SeoMeta {
  title: string;
  description: string;
  keywords: string;
  ogTitle?: string;
  ogDescription?: string;
}

const HOME_TITLE = "長崎県佐世保市のジビエ食肉加工・猪肉通販｜株式会社MEGURI";
const HOME_DESCRIPTION =
  "長崎県佐世保市の女猟師が営むジビエ食肉加工「株式会社MEGURI」。捕獲した猪を止め刺し・血抜き・精肉まで一人で行い、命を無駄なく循環させるジビエ猪肉を全国へ通販・販売しています。";

export const seoByPath: Record<string, SeoMeta> = {
  "/": {
    title: HOME_TITLE,
    description: HOME_DESCRIPTION,
    keywords: "ジビエ,猪,猪肉通販,佐世保,長崎,女猟師",
    ogTitle: HOME_TITLE,
    ogDescription:
      "女猟師が命をいただき、無駄なく循環させる。佐世保市のジビエ猪肉を通販で全国へ。",
  },
  "/products": {
    title: "猪肉通販・商品一覧｜株式会社MEGURI",
    description:
      "長崎県佐世保市のジビエ猪肉を通販で全国へ。おすすめパック、ペット用猪肉・鹿肉セットなど、株式会社MEGURIの商品一覧をご覧いただけます。",
    keywords: "猪肉通販,ジビエ通販,おすすめパック,ペット用猪肉,鹿肉,佐世保",
  },
  "/about": {
    title: "株式会社MEGURIについて｜命の循環を大切にするジビエ食肉加工",
    description:
      "女猟師が止め刺し・血抜き・精肉まで一人で行うジビエ食肉加工。命を無駄にせず循環させる株式会社MEGURIの想いをご紹介します。",
    keywords: "株式会社MEGURI,ジビエ,女猟師,命の循環,佐世保,長崎",
  },
  "/leather": {
    title: "猪革・レザー小物｜株式会社MEGURI",
    description:
      "猪の皮も無駄にせず、レザーとして生まれ変わらせる。Hummingbird × BOARKINの猪革レザー小物をご紹介します。",
    keywords: "猪革,レザー小物,BOARKIN,ジビエ,佐世保",
  },
  "/purchase": {
    title: "商品のご購入｜株式会社MEGURI",
    description:
      "株式会社MEGURIのジビエ商品をご購入いただけます。お支払いは銀行振込。商品をお選びいただき、必要事項をご入力ください。",
    keywords: "猪肉通販,ジビエ購入,銀行振込,佐世保,長崎",
  },
  "/contact": {
    title: "お問い合わせ｜株式会社MEGURI",
    description:
      "株式会社MEGURIへのお問い合わせは公式LINEから。商品についてのご質問やご相談をお気軽にお寄せください。",
    keywords: "お問い合わせ,株式会社MEGURI,公式LINE,ジビエ,佐世保",
  },
  "/access": {
    title: "アクセス｜株式会社MEGURI｜長崎県佐世保市",
    description:
      "株式会社MEGURIの所在地・アクセス情報。長崎県佐世保市日宇町1094-1。ご来訪の際は事前に公式LINEよりご連絡ください。",
    keywords: "アクセス,株式会社MEGURI,佐世保,長崎,日宇町",
  },
  "/legal": {
    title: "特定商取引法に基づく表記｜株式会社MEGURI",
    description: "株式会社MEGURIの特定商取引法に基づく表記です。",
    keywords: "特定商取引法,株式会社MEGURI",
  },
  "/privacy": {
    title: "プライバシーポリシー｜株式会社MEGURI",
    description: "株式会社MEGURIのプライバシーポリシーです。",
    keywords: "プライバシーポリシー,株式会社MEGURI",
  },
};

export function getSeoForPath(path: string): SeoMeta {
  return seoByPath[path] ?? seoByPath["/"];
}

// サイトの実オリジンを解決する。
// 環境変数 VITE_SITE_URL があればそれを優先し、無ければ現在の origin にフォールバック。
export function getSiteOrigin(): string {
  const configured = import.meta.env.VITE_SITE_URL as string | undefined;
  if (configured && configured.trim() && configured.trim() !== "/") {
    return configured.trim().replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }
  return "";
}